"use strict";
exports.__esModule = true;
exports.createDataTestId = void 0;
/**
 * Function that generates standard data test id. Both args should be kebab-case
 * Ex: add-company or generate-snapshot
 * @param component the component we want to add the id to. button, checkbox, dropdown are good examples
 * @param context the context of the component, aka, what it does. search-company, generate-pdf, etc
 * @returns
 */
var createDataTestId = function (component, context) { return ({ "data-testid": "".concat(component, "-").concat(context) }); };
exports.createDataTestId = createDataTestId;
